import type { IntentMatch, IntentName, ToolName, ToolResult } from './types';
import {
  mockGetMyBots,
  mockGetBotStatus,
  mockGetRecentOrders,
  mockGetPositions,
  mockGetPortfolio,
  mockGetAlerts,
  mockGetConnections,
  mockGetAgentWorkflowContext,
  mockGetConnectionPosture,
  mockGetStrategyCatalog,
  mockGetBacktestSummary,
  mockGetMonitoringHealth,
  mockGetComplianceQueue,
  mockGetTaxReconciliation,
  mockGetReportSnapshot,
  mockGetPageActionCatalog,
} from './mockTools';
import { searchKB } from './knowledgeBase';

const INTENT_TOOL_MAP: Partial<Record<IntentName, ToolName[]>> = {
  bot_status: ['mockGetMyBots'],
  bot_list: ['mockGetMyBots'],
  bot_diagnose: ['mockGetBotStatus', 'mockGetAlerts'],
  recent_orders: ['mockGetRecentOrders'],
  positions: ['mockGetPositions'],
  portfolio_overview: ['mockGetPortfolio'],
  connect_exchange: ['mockGetConnections'],
  agent_workflow: ['mockGetAgentWorkflowContext'],
  connection_audit: ['mockGetConnectionPosture'],
  strategy_action: ['mockGetStrategyCatalog'],
  backtest_action: ['mockGetBacktestSummary'],
  monitoring_triage: ['mockGetMonitoringHealth', 'mockGetAlerts'],
  compliance_review: ['mockGetComplianceQueue'],
  tax_reconcile: ['mockGetTaxReconciliation'],
  report_analysis: ['mockGetReportSnapshot'],
  workspace_action: ['mockGetPageActionCatalog'],
  kb_search: ['mockSearchKB'],
};

function executeTool(toolName: ToolName, intent: IntentMatch, route?: string): ToolResult {
  switch (toolName) {
    case 'mockGetMyBots':
      return mockGetMyBots();
    case 'mockGetBotStatus':
      return mockGetBotStatus(intent.extractedEntities.botId ?? intent.extractedEntities.botName);
    case 'mockGetRecentOrders':
      return mockGetRecentOrders();
    case 'mockGetPositions':
      return mockGetPositions();
    case 'mockGetPortfolio':
      return mockGetPortfolio();
    case 'mockGetAlerts':
      return mockGetAlerts();
    case 'mockGetConnections':
      return mockGetConnections();
    case 'mockGetAgentWorkflowContext':
      return mockGetAgentWorkflowContext();
    case 'mockGetConnectionPosture':
      return mockGetConnectionPosture();
    case 'mockGetStrategyCatalog':
      return mockGetStrategyCatalog();
    case 'mockGetBacktestSummary':
      return mockGetBacktestSummary();
    case 'mockGetMonitoringHealth':
      return mockGetMonitoringHealth();
    case 'mockGetComplianceQueue':
      return mockGetComplianceQueue();
    case 'mockGetTaxReconciliation':
      return mockGetTaxReconciliation();
    case 'mockGetReportSnapshot':
      return mockGetReportSnapshot();
    case 'mockGetPageActionCatalog':
      return mockGetPageActionCatalog(route);
    case 'mockSearchKB': {
      const keyword = intent.extractedEntities.keyword ?? '';
      const articles = searchKB(keyword);
      return {
        tool: 'mockSearchKB',
        executedAt: new Date().toISOString(),
        data: { articles },
      };
    }
    default:
      return { tool: toolName, executedAt: new Date().toISOString(), data: null };
  }
}

export function executeTools(intent: IntentMatch, route?: string): ToolResult[] {
  const toolNames = INTENT_TOOL_MAP[intent.intent] ?? [];
  return toolNames.map(toolName => executeTool(toolName, intent, route));
}
